import { NoteSource } from "../../../shared/types";

export const getSourcePlatform = (source: NoteSource): string => {
  if (NoteSource.MOBILE === source) {
    return "Mobile";
  }
  if (NoteSource.WEB === source) {
    return "Web";
  }
  return "Unknown";
};
